module.exports = __webpack_public_path__ + "img/after4-Recovered.7334b9d0.webp";